class ProductConfigurator extends HTMLElement {

    connectedCallback() {

        this.data = JSON.parse(this.dataset.products || '[]');

        this.minimum = Number(this.dataset.minimum || 20);

        this.vat = Number(this.dataset.vat || 20) / 100;

        this.printCharge = Number(this.dataset.printCharge || 0);

        this.currency = this.dataset.currency || '£';

        this.steps = [
            'Product',
            'Quantity',
            'Sizes',
            'Print Location',
            'Print Method',
            'Design',
            'Unit Cost',
            'Summary & Upload'
        ];

        this.state = {

            step: 0,

            category: null,

            product: null,

            variant: null,

            quantity: 0,

            sizes: {

                S: 0,

                M: 0,

                L: 0,

                XL: 0,

                '2XL': 0,

                '3XL': 0

            },

            locations: [],

            methods: {},

            printSizes: {},

            artwork: {}

        };

        this.listen();

        this.render();

    }


    listen() {

        this.addEventListener(
            'click',
            e => this.click(e)
        );

        this.addEventListener(
            'input',
            e => this.input(e)
        );

        this.addEventListener(
            'change',
            e => this.change(e)
        );

        this.addEventListener(
            'pointerdown',
            e => this.startDrag(e)
        );

    }


    money(n) {

        return `${this.currency}${Number(n || 0).toFixed(2)}`;

    }


    /*
    =========================================================
    SCROLL TO TOP OF CONFIGURATOR
    =========================================================
    */

    scrollToConfiguratorTop() {

        requestAnimationFrame(() => {

            requestAnimationFrame(() => {

                const rect =
                    this.getBoundingClientRect();

                const scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop ||
                    0;

                const targetTop =
                    scrollTop +
                    rect.top -
                    20;

                window.scrollTo({

                    top: Math.max(
                        0,
                        targetTop
                    ),

                    behavior: 'smooth'

                });

            });

        });

    }


    async uploadToCloudinary(file) {

        const cloudName = 'djydkuwod';

        const uploadPreset = 'Boxcey';

        const formData = new FormData();

        formData.append(
            'file',
            file
        );

        formData.append(
            'upload_preset',
            uploadPreset
        );

        try {

            const response = await fetch(
                `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
                {
                    method: 'POST',
                    body: formData
                }
            );

            const data =
                await response.json();

            if (!response.ok) {

                console.error(
                    'Cloudinary upload error:',
                    data
                );

                return null;

            }

            console.log(
                'Uploaded image URL:',
                data.secure_url
            );

            return data.secure_url;

        } catch (error) {

            console.error(
                'Cloudinary upload failed:',
                error
            );

            return null;

        }

    }


    dtfSizeCards(loc) {

        const sizes = [

            [
                '10×10 cm',
                '20',
                '20'
            ],

            [
                'A5 (14.8×21 cm)',
                '25',
                '35'
            ],

            [
                'A4 (21×29.7 cm)',
                '38',
                '52'
            ],

            [
                '30×30 cm',
                '52',
                '52'
            ],

            [
                'A3 (29.7×42 cm)',
                '44',
                '68'
            ]

        ];

        return sizes.map(
            ([label, w, h]) => `

                <button
                    class="pc__size-card pc__size-card--visual ${
                        this.state.printSizes[loc] === label
                            ? 'is-selected'
                            : ''
                    }"
                    data-print-size="${loc}|${label}">

                    <svg
                        viewBox="0 0 160 170"
                        aria-hidden="true">

                        <path
                            fill="#000"
                            d="M47 19 28 29 8 54l20 20 16-16v93h72V58l16 16 20-20-20-25-19-10-13 12H60z"/>

                        <rect
                            x="${80 - Number(w) / 2}"
                            y="${64 - Number(h) / 2}"
                            width="${w}"
                            height="${h}"
                            fill="#fff"/>

                    </svg>

                    <b>${label}</b>

                </button>

            `
        ).join('');

    }


    artworkPreviewSize(loc) {

        const sizes = {

            '10×10 cm': {
                width: '12.5%',
                height: '11.8%'
            },

            'A5 (14.8×21 cm)': {
                width: '15.6%',
                height: '20.6%'
            },

            'A4 (21×29.7 cm)': {
                width: '23.8%',
                height: '30.6%'
            },

            '30×30 cm': {
                width: '32.5%',
                height: '30.6%'
            },

            'A3 (29.7×42 cm)': {
                width: '27.5%',
                height: '40%'
            }

        };

        return (
            sizes[this.state.printSizes[loc]] ||
            sizes['10×10 cm']
        );

    }


    total() {

        if (!this.state.product) {

            return {

                unit: 0,

                base: 0,

                vat: 0,

                total: 0

            };

        }

        const unit =
            this.state.product.price +
            (
                this.state.locations.length *
                this.printCharge
            );

        const base =
            unit *
            this.state.quantity;

        const vat =
            base *
            this.vat;

        return {

            unit,

            base,

            vat,

            total:
                base + vat

        };

    }


    render() {

        this.querySelector(
            '.pc__steps'
        ).innerHTML =
            this.steps.map(
                (s, i) => `

                    <button
                        class="pc__step ${
                            i < this.state.step
                                ? 'pc__step--done'
                                : ''
                        } ${
                            i === this.state.step
                                ? 'pc__step--active'
                                : ''
                        }"
                        type="button"
                        data-goto-step="${i}"
                        ${
                            i > this.state.step
                                ? 'disabled'
                                : ''
                        }>

                        <b>
                            ${i + 1}
                        </b>

                        ${s}

                    </button>

                `
            ).join('');


        this.querySelector(
            '.pc__content'
        ).innerHTML =
            this.content();


        this.summary();


        this.querySelector(
            '.pc__progress'
        ).textContent =
            `Step ${this.state.step + 1} of 8`;


        this.querySelector(
            '[data-action="back"]'
        ).disabled =
            !this.state.step;


        const next =
            this.querySelector(
                '[data-action="next"]'
            );


        next.textContent =
            this.state.step === 7
                ? 'Add to cart'
                : 'Next';


        next.disabled =
            !this.valid();

    }


    content() {

        const s =
            this.state.step;


        if (s === 0) {

            return this.products();

        }


        if (s === 1) {

            return `
                <h2>
                    <span>∞</span>
                    Step 2: Quantity
                </h2>

                <div class="pc__quantity">

                    <button data-qty="-1">
                        −
                    </button>

                    <input
                        class="pc__quantity-input"
                        type="number"
                        min="0"
                        inputmode="numeric"
                        aria-label="Quantity"
                        value="${this.state.quantity}"
                        data-quantity>

                    <button data-qty="1">
                        ＋
                    </button>

                </div>

                ${
                    this.state.quantity &&
                    this.state.quantity < this.minimum
                        ? `
                            <p class="pc__notice">
                                Due to setup time and costs,
                                our minimum order quantity is
                                ${this.minimum} units.
                            </p>
                        `
                        : ''
                }
            `;

        }


        if (s === 2) {

            return this.sizes();

        }


        if (s === 3) {

            return this.locations();

        }


        if (s === 4) {

            return this.methods();

        }


        if (s === 5) {

            return this.design();

        }


        if (s === 6) {

            return this.cost();

        }


        return this.final();

    }


    products() {

        const c =
            this.state.category === null
                ? null
                : this.data[
                    this.state.category
                ];


        return `
            <h2>
                <span>♧</span>
                Step 1: Select Your Product
            </h2>

            <div class="pc__category-grid">

                ${
                    this.data.map(
                        (item, i) => `

                            <button
                                class="pc__choice ${
                                    i === this.state.category
                                        ? 'is-selected'
                                        : ''
                                }"
                                data-category="${i}">

                                ${
                                    item.icon
                                        ? `
                                            <img
                                                class="pc__choice-icon"
                                                src="${item.icon}"
                                                alt="">
                                        `
                                        : `
                                            <span
                                                class="pc__choice-icon">
                                                ♧
                                            </span>
                                        `
                                }

                                <b>
                                    ${item.title}
                                </b>

                                <small>
                                    ${item.products.length}
                                    products
                                </small>

                            </button>

                        `
                    ).join('')
                }

            </div>

            ${
                c
                    ? `
                        <div class="pc__collection-products">

                            <h3>
                                ${c.title} Products
                            </h3>

                            <div class="pc__product-grid">

                                ${
                                    c.products.map(
                                        (p, i) => `

                                            <article
                                                class="pc__product ${
                                                    this.state.product === p
                                                        ? 'is-selected'
                                                        : ''
                                                }">

                                                <img
                                                    src="${p.image}"
                                                    alt="">

                                                <div
                                                    class="pc__product-info">

                                                    <h3>
                                                        ${p.title}
                                                    </h3>

                                                    <div class="pc__price">
                                                        ${p.price_formatted}
                                                    </div>

                                                    <button
                                                        class="pc__mini-button pc__mini-button--black"
                                                        data-info="${i}">
                                                        Info
                                                    </button>

                                                    <button
                                                        class="pc__mini-button"
                                                        data-product="${i}">
                                                        Select
                                                    </button>

                                                </div>

                                            </article>

                                        `
                                    ).join('')
                                }

                            </div>

                        </div>
                    `
                    : ''
            }
        `;

    }


    sizes() {

        const allocated =
            Object.values(
                this.state.sizes
            ).reduce(
                (a, b) =>
                    a + Number(b),
                0
            );


        return `
            <h2>
                <span>♧</span>
                Step 3: Select Sizes
            </h2>

            <div class="pc__allocation">

                Total quantity needed:
                ${this.state.quantity}
                garments

                <br>

                Currently allocated:
                ${allocated}
                garments

                <br>

                <strong>
                    Remaining:
                    ${
                        this.state.quantity -
                        allocated
                    }
                    garments
                </strong>

            </div>

            <div class="pc__sizes">

                ${
                    Object.entries(
                        this.state.sizes
                    ).map(
                        ([size, n]) => `

                            <label>

                                ${size}

                                <input
                                    type="number"
                                    min="0"
                                    value="${n}"
                                    data-size="${size}">

                            </label>

                        `
                    ).join('')
                }

            </div>
        `;

    }


    locations() {

        return `
            <h2>
                <span>⌖</span>
                Step 4: Print Location
            </h2>

            <p>
                (Maximum 2 positions)
            </p>

            <div class="pc__locations">

                ${
                    ['Front', 'Back'].map(
                        x => `

                            <button
                                class="pc__location ${
                                    this.state.locations.includes(x)
                                        ? 'is-selected'
                                        : ''
                                }"
                                data-location="${x}">

                                <img
                                    src="${
                                        this.state.product?.image || ''
                                    }"
                                    alt="${x} product preview">

                                <b>
                                    ${x.toUpperCase()}
                                </b>

                            </button>

                        `
                    ).join('')
                }

            </div>
        `;

    }


    methods() {

        return `
            <h2>
                <span>ϟ</span>
                Step 5: Print Method
            </h2>

            ${
                this.state.locations.map(
                    (loc, i) => `

                        <div class="pc__method-row">

                            <h3>
                                ${i + 1}
                                ${loc}
                                Print Method
                            </h3>

                            <div class="pc__methods">

                                <button
                                    class="pc__method ${
                                        this.state.methods[loc] ===
                                        'DTF Transfer'
                                            ? 'is-selected'
                                            : ''
                                    }"
                                    data-method="${loc}|DTF Transfer">

                                    <b>
                                        DTF TRANSFER
                                    </b>

                                    <small>
                                        full-colour,
                                        detailed graphics
                                    </small>

                                </button>

                            </div>

                            ${
                                this.state.methods[loc] ===
                                'DTF Transfer'
                                    ? `
                                        <div
                                            class="pc__dtf-sizes">

                                            <h4>
                                                DTF Print Size
                                            </h4>

                                            <div
                                                class="pc__print-sizes pc__print-sizes--visual">

                                                ${this.dtfSizeCards(loc)}

                                            </div>

                                        </div>
                                    `
                                    : ''
                            }

                        </div>

                    `
                ).join('')
            }
        `;

    }


    design() {

        return `
            <h2>
                <span>◉</span>
                Step 6: Design Your Product
            </h2>

            <div class="pc__design">

                ${
                    this.state.locations.map(
                        loc => {

                            const art =
                                this.state.artwork[loc];

                            const selected =
                                !!art?.url;

                            const previewSize =
                                this.artworkPreviewSize(loc);


                            return `
                                <section
                                    class="pc__design-pane">

                                    <h3>
                                        ${loc}
                                        Design Preview
                                    </h3>

                                    <div
                                        class="pc__design-preview">

                                        <img
                                            class="product"
                                            src="${this.state.product.image}"
                                            alt="">

                                        <img
                                            class="art"
                                            data-art="${loc}"

                                            ${
                                                selected
                                                    ? `
                                                        src="${art.url}"

                                                        style="
                                                            left:${art.x ?? 50}%;
                                                            top:${art.y ?? 50}%;
                                                            width:${previewSize.width};
                                                            height:${previewSize.height};
                                                            object-fit:contain
                                                        "
                                                    `
                                                    : ''
                                            }>

                                    </div>

                                    ${
                                        selected
                                            ? `
                                                <button
                                                    class="pc__change-artwork"
                                                    type="button"
                                                    data-change-artwork="${loc}">

                                                    ↻ Change Artwork

                                                </button>

                                                <small>
                                                    Drag the artwork on the
                                                    product to position it.
                                                </small>
                                            `
                                            : `
                                                <input
                                                    id="cart-image-upload"
                                                    type="file"
                                                    accept="image/png,image/jpeg,image/svg+xml,application/pdf"
                                                    data-upload="${loc}">

                                                <small>
                                                    PNG, JPG, SVG or PDF;
                                                    300 DPI recommended.
                                                </small>
                                            `
                                    }

                                </section>
                            `;

                        }
                    ).join('')
                }

            </div>
        `;

    }


    cost() {

        const t =
            this.total();

        const allocated =
            Object.values(
                this.state.sizes
            ).reduce(
                (a, b) =>
                    a + Number(b),
                0
            );


        return `
            <h2>
                <span>£</span>
                Step 7: Unit Cost
            </h2>

            <div
                class="pc__card"
                style="padding:35px;text-align:center">

                <div
                    style="
                        font-size:54px;
                        font-weight:800;
                        color:#000
                    ">

                    ${this.money(t.total)}

                </div>

                <p>
                    Total Order Cost (inc VAT)
                </p>

                <div
                    class="pc__quantity"
                    style="font-size:20px">

                    <div>

                        <b>
                            ${this.state.quantity}
                        </b>

                        <br>

                        <small>
                            Units
                        </small>

                    </div>

                    <div>

                        <b>
                            ${
                                this.money(
                                    t.total /
                                    this.state.quantity
                                )
                            }
                        </b>

                        <br>

                        <small>
                            Per unit (inc VAT)
                        </small>

                    </div>

                </div>

            </div>

            <section
                class="pc__adjust-quantity">

                <h3>
                    Adjust Your Quantity
                </h3>

                <div class="pc__quantity">

                    <button data-qty="-1">
                        −
                    </button>

                    <input
                        class="pc__quantity-input"
                        type="number"
                        min="0"
                        inputmode="numeric"
                        aria-label="Quantity"
                        value="${this.state.quantity}"
                        data-quantity>

                    <button data-qty="1">
                        ＋
                    </button>

                </div>

            </section>

            <section
                class="pc__refine-sizes">

                <h3>
                    Refine Size Breakdown
                </h3>

                <p>
                    Adjust individual sizes if needed.
                    Your size distribution was set in Step 3.
                </p>

                <div class="pc__allocation">

                    Total quantity needed:
                    ${this.state.quantity}
                    garments

                    <br>

                    Currently allocated:
                    ${allocated}
                    garments

                    <br>

                    <strong>
                        Remaining:
                        ${
                            this.state.quantity -
                            allocated
                        }
                        garments
                    </strong>

                </div>

                <div class="pc__sizes">

                    ${
                        Object.entries(
                            this.state.sizes
                        ).map(
                            ([size, n]) => `

                                <label>

                                    ${size}

                                    <input
                                        type="number"
                                        min="0"
                                        value="${n}"
                                        data-size="${size}">

                                </label>

                            `
                        ).join('')
                    }

                </div>

            </section>
        `;

    }


    final() {

        return `
            <h2>
                <span>▧</span>
                Step 8: Summary & Upload Artwork
            </h2>

            <div class="pc__order-card">

                <h3>
                    Product Details
                </h3>

                <div class="pc__summary-product">

                    <img
                        src="${this.state.product.image}"
                        alt="${this.state.product.title}">

                    <p>

                        <b>
                            ${this.state.product.title}
                        </b>

                        <br>

                        Quantity:
                        ${this.state.quantity}
                        units

                        <br>

                        Sizes:
                        ${
                            Object.entries(
                                this.state.sizes
                            )
                            .filter(
                                ([, v]) => v
                            )
                            .map(
                                ([k, v]) =>
                                    `${v}× ${k}`
                            )
                            .join(', ')
                        }

                    </p>

                </div>

                <hr>

                <h3>
                    Print specifications
                </h3>

                ${
                    this.state.locations.map(
                        x => `

                            <p>

                                <b>
                                    ${x}
                                </b>

                                <br>

                                Method:
                                ${this.state.methods[x]}

                                ${
                                    this.state.printSizes[x]
                                        ? ` · ${this.state.printSizes[x]}`
                                        : ''
                                }

                                <br>

                                Artwork:
                                ${
                                    this.state.artwork[x]?.name ||
                                    'Not uploaded'
                                }

                            </p>

                        `
                    ).join('')
                }

            </div>
        `;

    }


    summary() {

        const el =
            this.querySelector(
                '.pc__summary'
            );


        if (!this.state.product) {

            el.className =
                'pc__summary pc__summary--empty';

            el.innerHTML =
                '<h3>£ &nbsp; Pricing Summary</h3>' +
                '<p>Complete your selections to see pricing</p>';

            return;

        }


        const t =
            this.total();


        el.className =
            'pc__summary';


        el.innerHTML = `
            <h3>
                £ &nbsp; Pricing Summary
            </h3>

            <p>
                Subtotal per unit
                <b>
                    ${this.money(t.unit)}
                </b>
            </p>

            <p>
                Quantity
                <b>
                    ${this.state.quantity} units
                </b>
            </p>

            <p>
                Base total
                <b>
                    ${this.money(t.base)}
                </b>
            </p>

            <p>
                VAT (${this.vat * 100}%)
                <b>
                    ${this.money(t.vat)}
                </b>
            </p>

            <p>

                <strong>
                    Total (inc VAT)
                </strong>

                <strong>
                    ${this.money(t.total)}
                </strong>

            </p>
        `;

    }


    valid() {

        const s =
            this.state.step;

        const a =
            Object.values(
                this.state.sizes
            ).reduce(
                (x, y) =>
                    x + Number(y),
                0
            );


        return [

            !!this.state.product,

            this.state.quantity >=
                this.minimum,

            a ===
                this.state.quantity,

            this.state.locations.length >
                0,

            this.state.locations.every(
                x =>
                    this.state.methods[x] &&
                    (
                        this.state.methods[x] !==
                        'DTF Transfer' ||
                        this.state.printSizes[x]
                    )
            ),

            true,

            a ===
                this.state.quantity,

            true

        ][s];

    }


    click(e) {

        const b =
            e.target.closest('button');


        if (!b) return;


        /*
        =========================================================
        STEP NUMBER CLICK
        =========================================================
        */

        if (
            b.dataset.gotoStep !== undefined
        ) {

            this.state.step =
                +b.dataset.gotoStep;

            this.render();

            /*
            IMPORTANT:
            Step click pachhi top par lai jase
            */

            this.scrollToConfiguratorTop();

        }


        /*
        =========================================================
        CATEGORY
        =========================================================
        */

        else if (
            b.dataset.category !== undefined
        ) {

            this.state.category =
                +b.dataset.category;

            this.render();

        }


        /*
        =========================================================
        PRODUCT
        =========================================================
        */

        else if (
            b.dataset.product !== undefined
        ) {

            const p =
                this.data[
                    this.state.category
                ].products[
                    +b.dataset.product
                ];

            const category =
                this.state.category;


            this.state = {

                step: 1,

                category,

                product: p,

                variant:
                    p.variants.find(
                        v => v.available
                    ) ||
                    p.variants[0],

                quantity: 0,

                sizes: {

                    S: 0,

                    M: 0,

                    L: 0,

                    XL: 0,

                    '2XL': 0,

                    '3XL': 0

                },

                locations: [],

                methods: {},

                printSizes: {},

                artwork: {}

            };


            this.render();

            /*
            Product select pachhi Step 2
            top par lai jase
            */

            this.scrollToConfiguratorTop();

        }


        /*
        =========================================================
        INFO
        =========================================================
        */

        else if (
            b.dataset.info !== undefined
        ) {

            this.info(
                this.data[
                    this.state.category
                ].products[
                    +b.dataset.info
                ]
            );

        }


        /*
        =========================================================
        QUANTITY
        =========================================================
        */

        else if (
            b.dataset.qty
        ) {

            this.state.quantity =
                Math.max(
                    0,
                    this.state.quantity +
                    Number(b.dataset.qty)
                );

            this.render();

        }


        /*
        =========================================================
        LOCATION
        =========================================================
        */

        else if (
            b.dataset.location
        ) {

            const x =
                b.dataset.location;


            this.state.locations =
                this.state.locations.includes(x)

                    ? this.state.locations.filter(
                        y => y !== x
                    )

                    : (
                        this.state.locations.length < 2
                            ? [
                                ...this.state.locations,
                                x
                            ]
                            : this.state.locations
                    );


            this.render();

        }


        /*
        =========================================================
        PRINT METHOD
        =========================================================
        */

        else if (
            b.dataset.method
        ) {

            const [l, m] =
                b.dataset.method.split('|');


            this.state.methods[l] =
                m;


            delete this.state.printSizes[l];


            this.render();

        }


        /*
        =========================================================
        PRINT SIZE
        =========================================================
        */

        else if (
            b.dataset.printSize
        ) {

            const [l, x] =
                b.dataset.printSize.split('|');


            this.state.printSizes[l] =
                x;


            this.render();

        }


        /*
        =========================================================
        CHANGE ARTWORK
        =========================================================
        */

        else if (
            b.dataset.changeArtwork
        ) {

            delete this.state.artwork[
                b.dataset.changeArtwork
            ];


            this.render();

        }


        /*
        =========================================================
        BACK BUTTON
        =========================================================
        */

        else if (
            b.dataset.action === 'back'
        ) {

            this.state.step =
                Math.max(
                    0,
                    this.state.step - 1
                );


            this.render();

            /*
            IMPORTANT:
            Back click pachhi top par lai jase
            */

            this.scrollToConfiguratorTop();

        }


        /*
        =========================================================
        NEXT BUTTON
        =========================================================
        */

        else if (
            b.dataset.action === 'next'
        ) {

            /*
            STEP 8 = ADD TO CART
            */

            if (
                this.state.step === 7
            ) {

                this.addCart();

            }


            /*
            NORMAL NEXT
            */

            else if (
                this.valid()
            ) {

                this.state.step++;

                this.render();

                /*
                IMPORTANT:
                Next click pachhi new step
                top thi open thase
                */

                this.scrollToConfiguratorTop();

            }

        }

    }


    async input(e) {

        if (
            e.target.dataset.quantity !== undefined
        ) {

            this.state.quantity =
                Math.max(
                    0,
                    parseInt(
                        e.target.value,
                        10
                    ) || 0
                );

            return;

        }


        if (
            e.target.dataset.size
        ) {

            this.state.sizes[
                e.target.dataset.size
            ] =
                Math.max(
                    0,
                    +e.target.value || 0
                );


            this.render();

            return;

        }


        if (
            e.target.dataset.upload &&
            e.target.files[0]
        ) {

            const file =
                e.target.files[0];

            const loc =
                e.target.dataset.upload;


            const imageUrl =
                await this.uploadToCloudinary(
                    file
                );


            if (!imageUrl) {

                alert(
                    'Artwork upload failed. Please try again.'
                );

                return;

            }


            this.state.artwork[loc] = {

                name:
                    file.name,

                url:
                    imageUrl,

                x: 50,

                y: 50

            };


            console.log(
                'Cloudinary Artwork URL:',
                imageUrl
            );


            this.render();

        }

    }


    startDrag(e) {

        const art =
            e.target.closest(
                '[data-art]'
            );


        if (
            !art ||
            !art.getAttribute('src')
        ) {

            return;

        }


        const loc =
            art.dataset.art;

        const preview =
            art.closest(
                '.pc__design-preview'
            );


        e.preventDefault();


        const move =
            event => {

                const r =
                    preview.getBoundingClientRect();


                const x =
                    Math.max(
                        0,
                        Math.min(
                            100,
                            (
                                (event.clientX - r.left) /
                                r.width
                            ) * 100
                        )
                    );


                const y =
                    Math.max(
                        0,
                        Math.min(
                            100,
                            (
                                (event.clientY - r.top) /
                                r.height
                            ) * 100
                        )
                    );


                art.style.left =
                    `${x}%`;

                art.style.top =
                    `${y}%`;


                this.state.artwork[loc].x =
                    x;

                this.state.artwork[loc].y =
                    y;

            };


        const end =
            () => {

                document.removeEventListener(
                    'pointermove',
                    move
                );

                document.removeEventListener(
                    'pointerup',
                    end
                );

            };


        document.addEventListener(
            'pointermove',
            move
        );

        document.addEventListener(
            'pointerup',
            end
        );

    }


    change(e) {

        if (
            e.target.dataset.quantity !== undefined
        ) {

            this.render();

        }

    }


    info(p) {

        const d =
            this.querySelector(
                '.pc__modal'
            );


        d.innerHTML = `

            <div class="pc__modal-inner">

                <button
                    class="pc__modal-close"
                    onclick="this.closest('dialog').close()">

                    ×

                </button>

                <h2>
                    Product Information
                </h2>

                <img
                    src="${p.image}"
                    alt="">

                <h3>
                    ${p.title}
                </h3>

                <p class="pc__price">
                    ${p.price_formatted}
                </p>

                <p>
                    ${
                        p.description ||
                        'No product description available.'
                    }
                </p>

            </div>

        `;


        d.showModal();

    }


    async addCart() {

        const props = {

            'Size breakdown':
                Object.entries(
                    this.state.sizes
                )
                .filter(
                    ([, v]) => v
                )
                .map(
                    ([k, v]) =>
                        `${v}× ${k}`
                )
                .join(', '),

            'Print locations':
                this.state.locations.join(', ')

        };


        this.state.locations.forEach(
            x => {

                props[
                    `${x} print method`
                ] =
                    this.state.methods[x];


                if (
                    this.state.printSizes[x]
                ) {

                    props[
                        `${x} print size`
                    ] =
                        this.state.printSizes[x];

                }


                if (
                    this.state.artwork[x]?.name
                ) {

                    props[
                        `${x} artwork file`
                    ] =
                        this.state.artwork[x].name;

                }


                if (
                    this.state.artwork[x]?.url
                ) {

                    props[
                        `${x} artwork URL`
                    ] =
                        this.state.artwork[x].url;

                }

            }
        );


        try {

            const r =
                await fetch(
                    this.dataset.cartUrl,
                    {

                        method: 'POST',

                        headers: {

                            'Content-Type':
                                'application/json',

                            'Accept':
                                'application/json'

                        },

                        body:
                            JSON.stringify({

                                items: [

                                    {

                                        id:
                                            this.state.variant.id,

                                        quantity:
                                            this.state.quantity,

                                        properties:
                                            props

                                    }

                                ]

                            })

                    }
                );


            if (!r.ok) {

                throw new Error();

            }


            window.location.href =
                '/cart';


        } catch {

            alert(
                'Unable to add this item to cart. Please try again.'
            );

        }

    }

}


customElements.define(
    'product-configurator',
    ProductConfigurator
);